import React, { Component } from "react";
import RemovableBadge from "../../RemovableBadge";
/**
 * <EventSyllabi editMode={} sylEvents={} removeSyl={}
 *  toggleTrueFalse={} />
 * props:
 *  - Boolean editMode
 *  - Booloean selectingInvitees
 *  - Array<object> sylEvents: [{syllabus_id, course_code},{...},...]
 *  - function removeSyl
 *  - function toggleTrueFalse
 **/
const EventSyllabi = (props) => {
  const sylList = props.sylEvents.map((syl, i) => {
    return (
      <RemovableBadge
        key={"syl-" + i}
        label={syl["course_code"] + " " + syl["course_name"]}
        handleRemove={props.removeSyl}
        stateKey="syl_events"
        stateIndex={i}
        toDestroy={syl["_destroy"] === 1}
        editMode={props.editMode}
      />
    );
  });

  const addBtn = props.editMode ? (
    <button
      className={
        props.selectingInvitees
          ? "btn btn-danger pl-1 pr-1 pt-0 pb-0 mr-2"
          : "btn btn-primary pl-1 pr-1 pt-0 pb-0 mr-2"
      }
      title="View list of potential syllabi"
      onClick={() => {
        props.toggleTrueFalse("selecting_invitees");
      }}
    >
      <strong>{props.selectingInvitees ? "x" : "+"}</strong>
    </button>
  ) : (
    ""
  );

  return (
    <div>
      {addBtn}
      <label>Relevant Courses:</label>
      <div className="card p-3">{sylList}</div>
    </div>
  );
};

export default EventSyllabi;
